import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import Select from "react-select";
import { isApparel } from "../helpers/productHelpers";
import { getProductType } from "../redux/creators/threekitCreators";
import OptionLabel from "./OptionLabel";

/**
 * Select dropdown for variant options
 * Function found in VariantOptions.js
 *
 * @param {Object}   option                Current option
 * @param {function} handleProductChange   Function to change selected product
 *
 * @returns {Object}
 */
export default function VariantSelectOption({ option, handleProductChange }) {
  const { selectedProduct, productType } = useSelector((state) => ({
    selectedProduct: state.threekit.selectedProduct,
    productType: getProductType(state),
  }));

  // Format options for React select
  const formattedOptions = option.values.map((value) => {
    return {
      value: value,
      label: value,
      disabled: isSoldOut(value)
    }
  });

  // If variant is sold out
  function isSoldOut(value) {
    let soldOutVariants = selectedProduct.variants.filter((variant) => !variant.available);
    let isSoldOut = false;

    // Apparel denotes sold out by color
    if (!isApparel(productType)) {
      soldOutVariants
        .map((variant) => variant.options)
        .forEach((options) => {
          if (options.includes(value)) {
            isSoldOut = true;
          }
        });
    }

    return isSoldOut;
  };

  return (
    <SelectContainer>
    <OptionLabel label={option.name} />
      <Select
        onChange={handleProductChange}
        name={option.name}
        options={formattedOptions}
        key={option.name}
        defaultValue={formattedOptions.find((option) => !option.disabled)}
        isOptionDisabled={(option) => option.disabled}
      />
    </SelectContainer>
  );
}

const SelectContainer = styled.div`
  width: 100%;
  padding-bottom: 24px;
`;
